import React from "react";
import "./style.css";
import icon from "../assets/Icon.png"
import { AiFillStar } from "react-icons/ai";


export default function Profile() {
    return(
        <div className="profile">
            <div className="profile_image_main">
                <div className="profile_image_main_image">
                    <img src={icon} alt="" />
                </div>
                
            </div>
            <div className="toprated">
                    <AiFillStar/>
                    <p>High Ranked</p>
            </div>
            <div style={{height:"80px"}}></div>
            <div className="profile_value">
                <div className="label">
                    ID
                </div>
                <div className="value">
                    0001
                </div>
            </div>
            <div className="profile_value">
                <div className="label">
                    Username
                </div>
                <div className="value">
                    yamin
                </div>
            </div>
            <div className="profile_value">
                <div className="label">
                    Full Name
                </div>
                <div className="value">
                    Muhammad Yamin
                </div>
            </div>
            <div className="profile_value">
                <div className="label">
                    Email
                </div>
                <div className="value">
                yamin@icdcmasjid.org
                </div>
            </div>
        </div>
    )
}